import { useEffect, useMemo } from 'react';
import { useLazyQuery } from '@apollo/client';
import { IS_FEATURE_FLAG_ENABLED_FOR_ORG } from 'meeopp-graphql/modules/feature-flag';
import { useEnabledFeatureFlags } from '../../contexts/feature-flag-provider';

export const useFeatureFlag = (featureName) => {
  if (!featureName) return { isLoading: false, isEnabled: false };
  const { enabledFeatureFlagsMap = {}, loading } = useEnabledFeatureFlags();

  const isEnabled = enabledFeatureFlagsMap[featureName] === true;
  return useMemo(
    () => ({
      isLoading: false,
      isEnabled,
    }),
    [isEnabled, loading]
  );
};

export const useFeatureFlagForOrg = (featureName, organizationId) => {
  const [getFeatureFlagStatus, { data, loading }] = useLazyQuery(IS_FEATURE_FLAG_ENABLED_FOR_ORG);

  useEffect(() => {
    if (featureName && organizationId) {
      getFeatureFlagStatus({
        variables: {
          featureName,
          organizationId,
        },
      });
    }
  }, [featureName, organizationId]);

  const isLoading = loading || !data;
  const isEnabled = data?.isFeatureFlagEnabledForOrg ?? false;

  return useMemo(
    () => ({
      isLoading,
      isEnabled,
    }),
    [isLoading, isEnabled]
  );
};
